import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { referralStatusLabel, referralStatusTone } from '../lib/referralStatus';
export function StatusBadge({ status, statuses, }) {
    const label = referralStatusLabel(status, statuses);
    const tone = referralStatusTone(label);
    const toneClass = tone === 'neutral' ? '' : ` status-tone-${tone}`;
    return (_jsxs("span", { className: `status-badge status-${status}${toneClass}`, children: [_jsx("span", { className: "status-badge-dot", "aria-hidden": "true" }), label] }));
}
